<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-send-email">    
    <div v-if="!isSent">
      <el-form :model="form" :rules="formRules" ref="form">
        <div class="reset-msg">{{ $t('login.resetPassword.message') }}</div>
        <el-form-item prop="email">
          <el-input v-model="form.email" type="text" :disabled="diableEmail" :placeholder="$t('login.resetPassword.emailPlaceholder')"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div v-else>
      <div class="reset-msg-sent">{{ $t('login.resetPassword.resetPasswordSentSuccessMsg') }}</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <div v-if="!isSent">
        <el-button class="wy-grey-button" @click="handleCancel" :disabled="isLoading">{{ $t('button.cancel') }}</el-button>
        <el-button class="wy-blue-button" @click="handleUpdate" :loading="isLoading">{{ $t('button.resetPassword') }}</el-button>
        <div v-if="isShowInfo" class="dialog-info" v-html="$t('login.resetPassword.info')" />
      </div>
      <div v-else>
        <el-button class="wy-grey-button" @click="handleCancel">{{ $t('button.close') }}</el-button>
      </div>
    </span>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'send-email-popup',
  props: ["controller", "isShowInfo", 'email'],
  data() {
    return {
      form: {
        email: ''
      },
      formRules: {
        email: [
          { required: true, message: this.$t('login.auth.emailRequired'), trigger: ['blur', 'change'] },
          { type: 'email', message: this.$t('login.auth.emailInvalid'), trigger: ['blur'] }
        ]
      },
      diableEmail: false,
      isLoading: false,
      isSent: false
    };
  },
  methods: {
    ...mapActions(['authRequestPassword']),
    
    handleCancel() {
      if(!this.isLoading) {
        this.controller.resetPasswordVisible = false;   
        this.isSent = false;        
      }      
    },
    handleUpdate() {
      this.$refs.form.validate(async (isValid) => {
        if (isValid) {
          this.isLoading = true;
          let res = await this.authRequestPassword(this.form.email);
          if(res.status === 200){
            this.$refs.form.resetFields();
            this.isSent = true;
          }
          else if(res.status === 400){
            this.$root.showNotificationLocale('error', 'login.resetPassword.resetPasswordSentFailedTitle', 'login.resetPassword.resetPasswordSentNoUserMsg');
          }
          else {
            this.$root.showNotificationLocale('error', 'login.resetPassword.resetPasswordSentFailedTitle', 'login.resetPassword.resetPasswordSentFailedMsg');
          }
          if(this.controller.accountMenu){
            this.controller.accountMenu.handleChangeVisible();
          }
          this.isLoading = false;
        }
      });
    },
  },
  mounted() {
    if(this.controller.profileForm && this.controller.profileForm.email && this.controller.profileForm.email != ''){
      this.form.email = this.controller.profileForm.email;
      this.diableEmail = true;
    }
    else if (this.email) {
      this.form.email = this.email;
    }
    else{
      this.diableEmail = false;
    }
    let closeLink = document.querySelector('.wy-link-click')
    if(closeLink) {
      closeLink.addEventListener('click', this.handleCancel);
    }
  }
}
</script>

<style lang="scss">
.wy-send-email {
  text-align: left;
  .reset-msg {
    font-size: 12px;
    text-align: left;
    word-break: normal;
    padding-bottom: 5px;
  }
  .reset-msg-sent {
    margin-bottom: 20px;
  }
  .el-input{
    padding-top: 10px;
    padding-bottom: 5px;
  }
  .el-form-item__content {
    margin-left: 0px !important;
    margin-bottom: 10px;
  }
  .el-form-item__error {
    text-align: left;
  }
  .dialog-info {
    font-size: 11.5px;
    margin-top: 15px;
    text-align: justify;
    line-height: 14px;
  }
}

.send-email-dialog {
  .el-dialog__header {
    background-image: url('../../assets/icons/alert_lock.svg');
  }
}
</style>
